import React from "react";
import { useInput } from "react-admin";
import avatarFemale from "../images/avatar_female.jpg";
import avatarMale from "../images/avatar_male.jpg";
import { customTheme } from "../customTheme";

export default function RaGenderInput(props) {
    const { input: { value, onChange } } = useInput(props);
    const { style } = props;

    return (
		<div style={{ display: "flex", alignItems: "center", columnGap: 12, ...style }}>
            <img
                src={avatarMale}
                className="avatarButton"
                alt="Male Avatar"
                onClick={() => onChange("Male")}
                style={value === "Male" ? { borderColor: customTheme.palette.primary.main } : undefined}
            />
            <img
                src={avatarFemale}
                className="avatarButton"
                alt="Female Avatar"
                onClick={() => onChange("Female")}
                style={value === "Female" ? { borderColor: customTheme.palette.primary.main } : undefined}
            />
        </div>
	);
}